import {request} from '@/utils/request'
import FlightOrder from "@/models/flightOrder";
import MvzItem from "@/models/dictionaries/mvzItem";
import SppItem from "@/models/dictionaries/sppItem";
import AgentAgreement from "@/models/dictionaries/agentAgreement";
import AkAgreement from "@/models/dictionaries/akAgreement";
import Organization from '@/models/dictionaries/organization'

const prefix = '/app/dictionaries'

const restService = {
  getDictionary: function (dictionaryName) {
    return request({
      url: `${prefix}/${dictionaryName}`,
      method: 'get'
    }).then(json => {
      switch (dictionaryName) {
        case 'mvz':
          return json.map(json => MvzItem.assign(json))
        case 'spp':
          return json.map(json => SppItem.assign(json))
        case 'agent-agreements':
          return json.map(json => AgentAgreement.assign(json))
        case 'ak-agreements':
          return json.map(json => AkAgreement.assign(json))
        case 'organizations':
          return json.map(json => Organization.assign(json))
        default:
          return json
      }
    })
  },
  saveDictionary: function (dictionaryName, data) {
    let url = `${prefix}/${dictionaryName}`
    return request({
      url,
      method: 'post',
      data
    })
  }
}

export default restService



// WEBPACK FOOTER //
// ./src/rest/freight/dictionaries.js